import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

export async function executeWithRetry(func, args, attempt, message = "") {
    const { error } = await func(args);
    const maxRetries = 2;
    if (error) {
        const concurrentModification = error.graphQLErrors.find(
            (e) => e.extensions.code === "ConcurrentModification"
        );
        if (concurrentModification && attempt < maxRetries) {
            return executeWithRetry(
                func,
                { ...args, version: concurrentModification.extensions.currentVersion },
                attempt + 1,
                "ConcurrentModification Retry"
            );
        }
        return { error };
    }
    if (attempt > 0) {
        Logger.info(ServiceType.COMMERCE_TOOLS, message, {
            tag: LogTag.ERROR,
            cartID: args.id,
            retry: attempt,
            service: "retry-" + process.env.NEXT_PUBLIC_HOSTNAME || "",
        });
    }
    return { error: null };
}
